import React from 'react';
import { ErrorsWrapper, useFormContext } from 'ui-builder';
import FormRows from '../FormRows';
import { FormLayoutProps } from '../index';
import { cn } from 'shadcn-ui';

function ShadcnDefaultLayout({
  children,
  buttons,
  className,
  title,
  testID,
  isSubmitting,
  buttonsBlockClassName,
}: FormLayoutProps) {

  let titleElement;

  if (typeof title === 'string') {
    titleElement = (
      <h3
        className="!text-2xl !font-medium !text-gray-800 !normal-case !tracking-tight !mb-0 !mt-0 !border-b-0 !pb-0"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        {title}
      </h3>
    );
  } else if (title) {
    titleElement = title;
  }

  const formContext = useFormContext();

  const isDisabled = formContext.isDisabled ? formContext.isDisabled() : false;

  return (
    <form
      data-testid={testID}
      className={cn(
        'flex flex-col gap-4',
        isSubmitting && 'opacity-50 pointer-events-none',
        className,
      )}
      autoComplete="nope"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <input autoComplete="nope" name="hidden" type="text" style={{ display: 'none' }} />
      {titleElement}
      <ErrorsWrapper name="__form">
        <FormRows>
          {children}
        </FormRows>
      </ErrorsWrapper>
      {buttons && !isDisabled && (
        <div className={cn('flex items-center justify-center gap-3', buttonsBlockClassName)}>
          {buttons}
        </div>
      )}
    </form>
  );
}

export default ShadcnDefaultLayout;
